// app/store.ts
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../auth/authSlice";
import { getChargeBack } from "../service/userTransactions/getChargeBack";
import { blackListCardApi } from "../service/useBlackListCard/useBlackListCard";
export const store = configureStore({
  reducer: {
    auth: authReducer,

    [getChargeBack.reducerPath]: getChargeBack.reducer,
    [blackListCardApi.reducerPath]: blackListCardApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(getChargeBack.middleware)
      .concat(blackListCardApi.middleware),
});

// Inferir tipos del store
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
